import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDUISectionStyleWrapper } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUISectionRenderer/SDUISectionStyleWrapper/SDUISectionStyleWrapper";
import { FilterablePaginatedSectionContextProvider } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import { FilterablePaginatedSectionWrapper } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionWrapper/FilterablePaginatedSectionWrapper";
import { SDUIFilterStoreProvider } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/SDUIFilterStoreProvider";
import { SDUIFilterablePaginatedSectionPaginationNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Pagination/SDUIFilterablePaginatedSectionPaginationNonRSC";
import { SDUIRetrievalQueriesNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/RetrievalQueries/SDUIRetrievalQueriesNonRSC";
import { SDUIFilterablePaginatedSectionComponentsColumnNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/SectionComponentsColumn/SDUIFilterablePaginatedSectionComponentsColumnNonRSC";
import { FilterablePaginatedSectionSideBarRendererNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Sidebar/FilterablePaginatedSectionSideBarRendererNonRSC";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
export var SDUIFilterablePaginatedSectionRenderer = function(_param) {
    var section = _param.section, rest = _object_without_properties(_param, [
        "section"
    ]);
    var filterablePaginatedSection = section.filterable_paginated_section;
    if (filterablePaginatedSection) {
        return /*#__PURE__*/ _jsx(SDUISectionStyleWrapper, {
            sectionStyles: section.style,
            children: /*#__PURE__*/ _jsx(FilterablePaginatedSectionRenderer, _object_spread({
                filterablePaginatedSection: filterablePaginatedSection
            }, rest))
        });
    }
    return null;
};
var FilterablePaginatedSectionRenderer = function(param) {
    var filterablePaginatedSection = param.filterablePaginatedSection, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData, numColumnsDesktop = param.numColumnsDesktop;
    return /*#__PURE__*/ _jsx(FilterablePaginatedSectionContextProvider, {
        children: /*#__PURE__*/ _jsxs(FilterablePaginatedSectionWrapper, {
            children: [
                /*#__PURE__*/ _jsx(SDUIRetrievalQueriesNonRSC, {
                    filterablePaginatedSection: filterablePaginatedSection
                }),
                /*#__PURE__*/ _jsxs(SDUIFilterStoreProvider, {
                    filterablePaginatedSection: filterablePaginatedSection,
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(FilterablePaginatedSectionSideBarRendererNonRSC, {
                                    filterablePaginatedSection: filterablePaginatedSection,
                                    sectionLoggingData: sectionLoggingData
                                }),
                                /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionComponentsColumnNonRSC, {
                                    filterablePaginatedSection: filterablePaginatedSection,
                                    componentRenderers: componentRenderers,
                                    sectionLoggingData: sectionLoggingData,
                                    numColumnsDesktop: numColumnsDesktop
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionPaginationNonRSC, {
                            filterablePaginatedSection: filterablePaginatedSection,
                            sectionLoggingData: sectionLoggingData
                        })
                    ]
                })
            ]
        })
    });
};
